// Header row 2 — section nav. Project-context tabs (Flows / Runs / Drift /
// Settings) when a project is selected; team-context items (Members, Billing)
// always visible on the right.

import { NavLink } from 'react-router-dom'

function tabClass({ isActive }) {
  return [
    'flex items-center gap-2 px-3 py-2 text-sm transition-colors',
    isActive
      ? 'font-medium text-[var(--color-basalt)] border-b-2 border-[var(--color-terracotta)] -mb-px'
      : 'text-[var(--color-slate)] border-b-2 border-transparent hover:bg-[var(--color-sandstone)] hover:text-[var(--color-basalt)]',
  ].join(' ')
}

export function SectionTabs({ teamId, projectId }) {
  const projectBase = teamId && projectId ? `/teams/${teamId}/projects/${projectId}` : null

  return (
    <nav
      aria-label="Section navigation"
      className="flex h-11 items-end gap-1 border-b border-[var(--color-sandstone)] px-4"
    >
      {projectBase && (
        <>
          <NavLink end to={`${projectBase}/flows`} className={tabClass}>
            Flows
          </NavLink>
          <NavLink end to={`${projectBase}/runs`} className={tabClass}>
            Runs
          </NavLink>
          <NavLink end to={`${projectBase}/drift`} className={tabClass}>
            Drift
          </NavLink>
          <NavLink end to={`${projectBase}/settings`} className={tabClass}>
            Settings
          </NavLink>
        </>
      )}

      {teamId && (
        <>
          {projectBase && (
            <span aria-hidden="true" className="px-1 text-[var(--color-schist)]">
              ·
            </span>
          )}
          <NavLink end to={`/teams/${teamId}/members`} className={tabClass}>
            Members
          </NavLink>
          <NavLink end to={`/teams/${teamId}/ai-models`} className={tabClass}>
            AI Models
          </NavLink>
          <NavLink end to={`/teams/${teamId}/billing`} className={tabClass}>
            Billing
          </NavLink>
        </>
      )}
    </nav>
  )
}
